import React, {Component} from 'react'
import FontIcon from 'material-ui/FontIcon';

import './notice.scss'

const Notice = ({
  className,
  error,
  alert,
  success,
  header,
  note,
  children,
}) => (
  <div>
    <div className={`notice ${className}`}>
      <div className="flex-center--horizontal">
        {error &&
          <FontIcon className="material-icons medium-spacing2--right" style={{fontSize: 36}}>error_outline</FontIcon>
        }
        {alert &&
          <FontIcon className="material-icons medium-spacing2--right" style={{fontSize: 36}}>info_outline</FontIcon>
        }
        {success &&
          <FontIcon className="material-icons medium-spacing2--right" style={{fontSize: 36, color: "#49A74C"}}>check_circle</FontIcon>
        }
        <h4>{header}</h4>
      </div>
      <p className="body2 medium-spacing--top">{note || children}</p>
    </div>
  </div>
)

export default Notice



// WEBPACK FOOTER //
// ./app/components/Notice.js